import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { InvitedModel } from 'common/models/page-models/Invited Students Model/invited-grid-data.model';
import { InvitedListingModel, InvitedGridParams } from 'common/models/page-models/Invited Students Model/invited-grid-params.model';
import { GridDataService } from '../../base-data-services/grid-data.service';


@Injectable({
    providedIn: 'root'
})
export class InvitedGridDataService extends GridDataService<InvitedListingModel, InvitedModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.allAssignmentStudentList, http, ss);
    }

    createInstance(): InvitedListingModel {
        return new InvitedListingModel();
    }

    override getGridParams(param): GridPostParams {
        let params;
        params = new InvitedGridParams();
        params.id = param.id;
        // params.id = 72;
        params.sortBy = "invited";
        return params;
    }

    override getDataParam() {
        return 'student_info';
    }

    override getExtraParam() {
        return 'details';
    }

    getDeleteUrl() {
        return '';
    }

    override transformDataModel(data: any, param) {
        super.transformDataModel(data, param);
        // console.log(data,param, "dataaaaaa");
    
        // Ensure data.details exists and process it
        if (data.details && data.details.student_info) {
            // Iterate over the student_info array to apply transformations
            data.details.student_info.forEach((student) => {
                // Set default values for student-related properties if they are null or empty
                student.student_ratings = student.student_ratings === "" || student.student_ratings === null ? 0 : student.student_ratings;
                student.score = student.score !== null && student.score !== undefined ? student.score : "0";
                student.student_feedback = student.student_feedback ? student.student_feedback : "";
                student.trainer_feedback_to_student = student.trainer_feedback_to_student ? student.trainer_feedback_to_student : "";
                student.trainer_feedback_to_admin = student.trainer_feedback_to_admin ? student.trainer_feedback_to_admin : "";
                student.signedUrl_student_file_submit = student.signedUrl_student_file_submit ? student.signedUrl_student_file_submit : "";
            });
            data.student_info = data.details.student_info
            // console.log(data);
            
        }
    
        return data;
    }

}
